import Transformer from './../transformer'
import { shortDate } from './../../filters'

class ConsolidatedSuppliesTransformer extends Transformer {
    static fetch(consolidated) {
      return {
        id: consolidated.id,
        supplyName: consolidated.supply.supply_name,
        supplyDescription: consolidated.supply.desciption,
        supplyUnitMeasurement: consolidated.supply.unit_measurement,
        quantity: parseFloat(consolidated.quantity),
        unitPrice: parseFloat(consolidated.unit_price),
        subTotal: parseFloat(consolidated.buy_order_price),
        code: consolidated.supply.code,
        freight: parseFloat(consolidated.freight_cost),
        subFreight: parseFloat(consolidated.freight_cost)*parseFloat(consolidated.quantity),
        total: parseFloat(consolidated.total_price),
      }
    }
  }

export default class PurchaseOrderSuppliesTransformer extends Transformer {
  static fetch(order) {
    let supplies = ConsolidatedSuppliesTransformer.fetchCollection(order.supplies_consolidated)
    return {
      id: order.id,
      folio: order.folio,
      consolidatedSupplies: supplies,
      addDate: shortDate(order.add_date),
      deliveryDate: shortDate(order.expected_delivery_date),
      sendConditions: order.send_conditions,
      paymentConditions: order.payment_conditions,
      orderWarehouseName: order.iwarehouse ? order.iwarehouse.iwarehouse_name : ""
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/purchaseOrdersSupplies.js